/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttributeStyleIdentifierDTO
 */
export interface AttributeStyleIdentifierDTO {
    /**
     * 
     * @type {string}
     * @memberof AttributeStyleIdentifierDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AttributeStyleIdentifierDTO
     */
    value: string;
}

/**
 * Check if a given object implements the AttributeStyleIdentifierDTO interface.
 */
export function instanceOfAttributeStyleIdentifierDTO(value: object): value is AttributeStyleIdentifierDTO {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function AttributeStyleIdentifierDTOFromJSON(json: any): AttributeStyleIdentifierDTO {
    return AttributeStyleIdentifierDTOFromJSONTyped(json, false);
}

export function AttributeStyleIdentifierDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributeStyleIdentifierDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function AttributeStyleIdentifierDTOToJSON(value?: AttributeStyleIdentifierDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

